import AirDatepicker from 'air-datepicker';
import localeEn from 'air-datepicker/locale/en';
import { getBreakpoints } from '../../../utils/utils';

class calendar {
  constructor() {
    this.disabledDate = new Date();
    this.datePicker = null;
    this.pendingDates = null;
    this.onSelectCallback = null;
    this.onRefreshCallback = null;
    this.dateElem = document.querySelector('.experience-select__label--date');
    this.datePickerInput = document.getElementById('air-date-picker');

    this.init();
  }

  init() {
    document.addEventListener('DOMContentLoaded', () => {
      this.initDatePicker();
    });

    window.addEventListener('resize', () => {
      const position = `bottom ${window.innerWidth > getBreakpoints().lg ? 'right' : 'left'}`;
      this.datePicker.update({ position });
    });
  }

  initDatePicker() {
    const position = `bottom ${window.innerWidth > getBreakpoints().lg ? 'right' : 'left'}`;
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // eslint-disable-next-line no-new
    this.datePicker = new AirDatepicker(this.datePickerInput, {
      startDate: today,
      minDate: today,
      range: true,
      locale: localeEn,
      isMobile: false,
      autoClose: true,
      displayMonths: 2,
      dateFormat: 'MMMM d, yyyy',
      position,
      buttons: [
        {
          content: 'Clear',
          onClick: (dp) => {
            dp.clear();
            dp.hide();
          },
        },
      ],
      onSelect: ({ date, formattedDate }) => {
        this.actionOnSelect(formattedDate);
        if (this.onSelectCallback) {
          this.onSelectCallback(date, formattedDate);
        }

        if (this.onRefreshCallback && (formattedDate.length === 2 || formattedDate.length === 0)) {
          this.onRefreshCallback();
        }
      },
    });

    let wasVisible = false;
    this.datePickerInput.addEventListener('mousedown', () => {
      wasVisible = this.datePicker.visible;
    });

    this.datePickerInput.addEventListener('click', () => {
      if (wasVisible) {
        this.datePicker.hide();
      }
    });

    if (this.pendingDates) {
      this.setDates(this.pendingDates);
      this.pendingDates = null;
    }
  }

  clear() {
    this.datePicker.clear();
  }

  setDates(dates) {
    if (!dates || dates.length !== 2) {
      return;
    }

    if (!this.datePicker) {
      this.pendingDates = dates;
      return;
    }

    const startDate = typeof dates[0] === 'string' ? new Date(dates[0]) : dates[0];
    const endDate = typeof dates[1] === 'string' ? new Date(dates[1]) : dates[1];

    this.datePicker.clear();
    this.datePicker.selectDate([startDate, endDate]);
  }

  getDates() {
    return this.datePicker ? this.datePicker.selectedDates : [];
  }

  getDatesFormatted() {
    if (!this.datePicker || !this.datePicker.selectedDates.length) {
      return [];
    }
    return this.datePicker.selectedDates.map((d) => {
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    });
  }

  onSelect(callback) {
    this.onSelectCallback = callback;
  }

  onRefresh(callback) {
    this.onRefreshCallback = callback;
  }

  actionOnSelect(formattedDate) {
    const dateWrapper = this.dateElem;
    const dateDisplay = dateWrapper.querySelector('span');
    let dateString = '';

    if (formattedDate.length > 0) {
      this.dateElem.classList.add('active');
      dateString += formattedDate[0];

      if (formattedDate.length === 2) {
        dateString += ` - ${formattedDate[1]}`;
      }
    } else {
      this.dateElem.classList.remove('active');
      dateString = dateDisplay.getAttribute('data-placeholder');
    }

    dateDisplay.innerText = dateString;
  }
}

export default calendar;
